var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84294 1.58966C9.71753 1.4276 9.57207 1.28215 9.41002 1.15674C9.04043 0.870715 8.61093 0.754038 8.12581 0.70106C7.65929 0.650114 7.07592 0.652726 6.36214 0.655924L4.46699 0.66438C4.15633 0.665766 3.90562 0.918726 3.90701 1.22938C3.90839 1.54004 4.16135 1.79075 4.47201 1.78937L6.33361 1.78106C7.08914 1.77769 7.60825 1.77623 8.00368 1.81941C8.13219 1.83344 8.23959 1.85153 8.33079 1.87339L0.359442 9.84474C0.139773 10.0644 0.139772 10.4206 0.359442 10.6402C0.579112 10.8599 0.935268 10.8599 1.15494 10.6402L9.12629 2.66888C9.14815 2.76009 9.16623 2.86749 9.18026 2.996C9.22345 3.39142 9.22198 3.91053 9.21861 4.66606L9.21031 6.52767C9.20892 6.83832 9.45963 7.09128 9.77029 7.09267C10.0809 7.09406 10.3339 6.84334 10.3353 6.53268L10.3437 4.63753C10.3469 3.92375 10.3496 3.34038 10.2986 2.87387C10.2456 2.38874 10.129 1.95924 9.84294 1.58966Z",
    fill: "#E63946"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightArrow);
export default __webpack_public_path__ + "static/media/top-right-arrow.7b1c7c608d6e8dc9adcc507c1a9114da.svg";
export { ForwardRef as ReactComponent };